export const getLocalizedText = (value) => {
  if (value == null || value === '') {
    return null;
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return value;
  }
  if (typeof value === 'object') {
    return value.default || value.en || Object.values(value)[0];
  }
  return null;
};

export const formatCellValue = (value) => {
  const text = getLocalizedText(value);
  return text != null ? text : 'N/A';
};
